import styled from "styled-components";
import { ThemeType } from "../../types/Theme";

const TituloContainer = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  .titulo {
    color: ${({ theme }) => theme.colors.tertiary} !important;
  }
  .subtitulo {
    font-weight: bold !important;
    color: ${({ theme }) => theme.colors.secondary} !important;
  }
`;

export { TituloContainer };
